import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  resolveActiveSearch,
  sanitizeVehicleSuffixInput,
  sanitizeChassisSuffixInput,
  getFindVehiclesValidationMessage,
} from "./findVehiclesHelpers";
import VehicleChassisSearchBar from "./VehicleChassisSearchBar";
import FindVehiclesStatsPanel from "../../../components/findVehicles/FindVehiclesStatsPanel";
import "../../../styles/vehicles.css";

export default function FindVehicles() {
  const navigate = useNavigate();
  const [draftVehicle, setDraftVehicle] = useState("");
  const [draftChassis, setDraftChassis] = useState("");
  const [lastInteraction, setLastInteraction] = useState("vehicle");
  const [formError, setFormError] = useState("");

  useEffect(() => {
    const resolved = resolveActiveSearch(draftVehicle, draftChassis, lastInteraction);
    setFormError(
      resolved
        ? ""
        : getFindVehiclesValidationMessage(draftVehicle, draftChassis, lastInteraction)
    );
    if (!resolved) return undefined;
    const timer = setTimeout(() => {
      navigate(
        `/find-vehicles/results?q=${encodeURIComponent(resolved.normalized)}&type=${resolved.mode}`,
        { replace: true }
      );
    }, 320);
    return () => clearTimeout(timer);
  }, [draftVehicle, draftChassis, lastInteraction, navigate]);

  return (
    <div className="find-vehicles-page fv-find-home-layout">
      <div className="fv-header fv-desktop-only">
        <h1>Find Medicines</h1>
      </div>

      <div className="fv-search-card fv-mobile-search-shell">
        <VehicleChassisSearchBar
          draftVehicle={draftVehicle}
          draftChassis={draftChassis}
          onVehicleChange={(value) => {
            setLastInteraction("vehicle");
            setDraftVehicle(sanitizeVehicleSuffixInput(value));
          }}
          onChassisChange={(value) => {
            setLastInteraction("chassis");
            setDraftChassis(sanitizeChassisSuffixInput(value));
          }}
          onVehicleFocus={() => setLastInteraction("vehicle")}
          onChassisFocus={() => setLastInteraction("chassis")}
          onClearVehicle={() => setDraftVehicle("")}
          onClearChassis={() => setDraftChassis("")}
        />

        {formError && <p className="fv-error">{formError}</p>}
      </div>

      <FindVehiclesStatsPanel />
    </div>
  );
}
